import { useEffect, useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const FIELDS = [
  { key: 'reader', label: 'القارئ / القارئة', type: 'text', placeholder: 'اسم القارئ' },
  { key: 'author', label: 'المؤلف', type: 'text', placeholder: 'اسم المؤلف' },
  { key: 'min_pages', label: 'من عدد صفحات', type: 'number', placeholder: '0' },
  { key: 'max_pages', label: 'إلى عدد صفحات', type: 'number', placeholder: '1000' },
  { key: 'date_from', label: 'من تاريخ', type: 'date' },
  { key: 'date_to', label: 'إلى تاريخ', type: 'date' },
];

export const MoreFilters = ({ values, onApply }) => {
  const [draft, setDraft] = useState(values);
  useEffect(() => { setDraft(values); }, [values]);
  return (
    <div className="space-y-4 text-right" dir="rtl" data-testid="more-filters-panel">
      <div className="grid grid-cols-2 gap-3">
        {FIELDS.map((f) => (
          <label key={f.key} className={`space-y-1 ${f.type === 'text' ? 'col-span-2' : ''}`}>
            <span className="text-xs font-semibold text-muted-foreground">{f.label}</span>
            <Input type={f.type} min={f.type === 'number' ? 0 : undefined} value={draft[f.key] || ''} placeholder={f.placeholder}
              onChange={(e) => setDraft({ ...draft, [f.key]: e.target.value })} className="h-10 text-sm" data-testid={`more-filter-${f.key}`} />
          </label>
        ))}
      </div>
      <div className="flex gap-2">
        <Button onClick={() => onApply(draft)} className="flex-1 bg-[#C19A6B] hover:bg-[#A9845A] text-white" data-testid="more-filters-apply">تطبيق</Button>
        <Button variant="outline" onClick={() => onApply(Object.fromEntries(FIELDS.map((f) => [f.key, ''])))} data-testid="more-filters-reset">مسح</Button>
      </div>
    </div>
  );
};

export const MORE_FILTER_KEYS = FIELDS.map((f) => f.key);
